import {IRoutableModule} from '../../router/routing.infra';
import {SessionEndedView} from './session-ended.view';
import {sessionEndedRouteLoader} from './session-ended.loader';

export default {
    loader: sessionEndedRouteLoader,
    Component: SessionEndedView,
    storeAs: 'sessionEndedStore'
} as IRoutableModule;
